const ROWS = [
  { label: "border-soft", className: "border-border-soft" },
  { label: "border", className: "border-border" },
  { label: "border-strong", className: "border-border-strong" },
] as const;

export function BorderScale() {
  return (
    <div className="space-y-4">
      {ROWS.map(row => (
        <div
          key={row.label}
          className={`rounded-md border-2 bg-surface-1/50 px-4 py-4 ${row.className}`}
        >
          <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ink-tertiary">
            {row.label}
          </p>
        </div>
      ))}
    </div>
  );
}
